import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('@/views/Forgot.vue')
  },
  {
    path: '/information',
    name: 'Information',
    component: () => import('@/views/Information.vue')
  },
  {
    path: '/orderForm',
    name: 'OrderForm',
    component: () => import('@/views/OrderForm.vue')
  },
  {
    path: '/teamDetail',
    name: 'TeamDetail',
    component: () => import('@/views/TeamDetail.vue')
  }
]
const env = process.env.NODE_ENV;
const router = createRouter({
  // createWebHistory
  history: env === "production" ? createWebHashHistory() : createWebHashHistory(),
  routes
})

export default router
